import { render, staticRenderFns } from "./DataTableFooter.vue?vue&type=template&id=2e3fff31&"
import script from "./DataTableFooter.vue?vue&type=script&lang=ts&"
export * from "./DataTableFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports